import i18n from '../../../../infrastructure/i18n';

export const getDisconnectedText = (controllerDC?: boolean, channelDC?: boolean): string => {
  if (controllerDC) {
    return i18n.t('statuses.activity.controller.disconnected');
  }

  if (channelDC) {
    return i18n.t('statuses.activity.channel.disconnected');
  }

  return '';
};
